import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {AccordionModule} from 'primeng/accordion';     //accordion and accordion tab
import { TabViewModule } from 'primeng/tabview';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { InputMaskModule } from 'primeng/inputmask';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { InputSwitchModule } from 'primeng/inputswitch';

import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MenuItem} from 'primeng/api'; 
import {ChartModule} from 'primeng/chart';
import { DashboardComponent } from './layout/dashboard/dashboard.component';
import { ExcursionComponent } from './excursion/excursion.component';
import { LogintemplateComponent } from './logintemplate/logintemplate.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import {CalendarModule} from 'primeng/calendar';
import {CardModule} from 'primeng/card';
// import {DropdownModule} from 'primeng/dropdown';
import { NgSelectModule } from '@ng-select/ng-select';
import { PrimeNGConfig } from 'primeng/api';
import {SidebarModule} from 'primeng/sidebar';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {InputTextModule} from 'primeng/inputtext';
import { EmailComponent } from './layout/email/email.component';
//import { RichTextEditor } from '@syncfusion/ej2-angular-richtexteditor';
//import { RichTextEditorModule } from '@syncfusion/ej2-angular-richtexteditor';
// import {DropdownModule} from 'primeng/dropdown';
import {TableModule} from 'primeng/table';
import {DialogModule} from 'primeng/dialog';
import {TabMenuModule} from 'primeng/tabmenu';
// import {TriStateCheckboxModule} from 'primeng/tristatecheckbox';
import {CheckboxModule} from 'primeng/checkbox';
import {InputTextareaModule} from 'primeng/inputtextarea';
import { FilterSearchPipe } from './pipe/filter-search.pipe';
import { DailyreportComponent } from './dailyreport/dailyreport.component';
import { DashboardsettingComponent } from './dashboardsetting/dashboardsetting.component';
import {DropdownModule} from 'primeng/dropdown';
import { JoditAngularModule } from 'jodit-angular';
import {ToastModule} from 'primeng/toast';
import {AutocompleteLibModule} from 'angular-ng-autocomplete';
import { ToastrModule } from 'ngx-toastr';
import { HomeComponent } from './home/home.component';
import { DatePipe } from '@angular/common';
import { AutoFocusIPDirective } from './auto-focus-ip.directive';
import {ScrollPanelModule} from 'primeng/scrollpanel';
// import {RouterModule} from '@angular/router';
import { TooltipModule } from 'primeng/tooltip';
import { InternalLoginComponent } from './internal-login/internal-login.component';
import { TransferComponent } from './transfer/transfer.component';
import { SupplierConfirmationComponent } from './supplier-confirmation/supplier-confirmation.component';
import { ArrDepReportComponent } from './arr-dep-report/arr-dep-report.component';
// import {MessagesModule} from 'primeng/messages';
// import {MessageModule} from 'primeng/message';
// import {RippleModule} from 'primeng/ripple';
// import {MenuItem} from 'primeng/api';
@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    ExcursionComponent,
    LogintemplateComponent,
    SidebarComponent,
    EmailComponent,
    FilterSearchPipe,
    DailyreportComponent,
    DashboardsettingComponent,
    HomeComponent,
    InternalLoginComponent,
    TransferComponent,
    SupplierConfirmationComponent,
    ArrDepReportComponent
    
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    
    AccordionModule,
    ChartModule,CalendarModule,
    CardModule,
    NgSelectModule,
    SidebarModule,HttpClientModule,FormsModule, ReactiveFormsModule,
    InputTextModule,
    TableModule,DialogModule,TabMenuModule,
    CheckboxModule,
    InputTextareaModule,
    DropdownModule,
    JoditAngularModule,
    ToastModule,
    TooltipModule,
    AutocompleteLibModule,
    ScrollPanelModule,
    ToastrModule.forRoot(),
    TabViewModule,
    AutoCompleteModule,
    InputMaskModule,
    ProgressSpinnerModule,
    InputSwitchModule
    //RichTextEditorModule
  ],
  providers: [DatePipe,AutoFocusIPDirective],
  bootstrap: [AppComponent]
})
export class AppModule { }
